//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Страницы</p>
    <div v-if="(cmsPages != null)">
      <entity-manager :data="cmsPages" :options="cmsPagesEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span v-if="viewProps.column.field == 'content'">
            <span v-if="(viewProps.dataRow.val[viewProps.column.field] != -1) && (viewProps.dataRow.val[viewProps.column.field] != '') && (viewProps.dataRow.val[viewProps.column.field] != null)">
              Есть
            </span>
            <span v-else>
              Нет
            </span>
          </span>
          <span v-else>
            {{viewProps.dataRow.val[viewProps.column.field]}}
          </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="(viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'url') || (viewProps.fieldKey == 'content')">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" style="width:100%"></Input>
          </span>
          <div v-else style="width:100%; height: 26px">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </div>
        </template>
      </entity-manager>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

export default {
  data () {
    return {
      cmsPages: null,
      cmsPagesEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Название', width: '', field: 'name'},
          {title: 'URL', width: '160px', field: 'url'},
          {title: 'Контент', width: '70px', field: 'content'}
        ],
        editorFields: {name: 'Название', url: 'URL', content: 'Контент', id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsPageResource)
          result.val = {}
          result.val.name = ''
          result.val.url = ''
          result.val.content = -1
          return result
        },
        commonDataReloadOptions: {},
        disableDelete: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'commonData'
    ])
  },
  components: { EntityManager },
  created: function () {
    var thisRef = this

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var cmsPages = []
    var cmsPageResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsPageResource)
    cmsPageResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneCMSPageResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsPageResource)
        oneCMSPageResource.val = response.data[itemIndx]
        cmsPages.push(oneCMSPageResource)
      }
      thisRef.cmsPages = cmsPages
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Pages.vue?69640a86